import { Document, Font } from "@react-pdf/renderer";
import { payerTypeConstants } from "constants/payer";
import { useMemo, useEffect } from "react";

import { Props } from "../ClearOrderDocument";
import { CommercialDocument } from "./Commecrial/CommercialDocument";
import { MedicareDocument } from "./Medicare/MedicareDocument";

export function AbnDocument(data: Props) {
  useEffect(() => {
    Font.register({
      family: "Helvetica-Oblique",
      src: "Helvetica-Oblique.ttf",
    });
  }, []);
  const isMedicare = useMemo(() => {
    return data?.activeAbnNotice?.payer?.type === payerTypeConstants.MEDICARE;
  }, [data?.activeAbnNotice?.payer?.type]);

  return (
    <Document>
      {isMedicare ? (
        <MedicareDocument {...data} />
      ) : (
        <CommercialDocument {...data} />
      )}
    </Document>
  );
}
